import { cva } from "styled-system/css";

export const buttonCardRecipe = cva({
  base: {
    padding: "300",
    bg: "white",
    display: "flex",
    width: "100%",
    flexDir: "column",
    gap: "50",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    borderRadius: "100",
    cursor: "pointer",
    outlineWidth: "1px",
    outlineStyle: "solid",
    outlineColor: "transparent",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "border.light",
    transitionDuration: "normal",
    transitionProperty: "outline, border",
    transitionTimingFunction: "default",
    _hover: {
      outlineColor: "border.mid",
      borderColor: "border.mid",
    },
    _focusVisible: {
      outlineColor: "border.mid",
      borderColor: "border.mid",
    },
    _selected: {
      outlineColor: "border.dark",
      borderColor: "border.dark",
      _hover: {
        outlineColor: "border.dark",
        borderColor: "border.dark",
      },
      _focusVisible: {
        outlineColor: "border.dark",
        borderColor: "border.dark",
      },
    },
  },
  variants: {
    /** `start`: left-aligned tile for grids (Promos > new-widget-modal, 111:7177). */
    align: {
      center: {},
      start: {
        alignItems: "flex-start",
        justifyContent: "flex-start",
        textAlign: "left",
        gap: "150",
        borderRadius: "150",
      },
    },
  },
  defaultVariants: {
    align: "center",
  },
});
